import request from "@/utils/request";

export function getPartners() {
  return request({
    url: `/api/guidebookv3/admin/partners/`,
    method: `get`,
  });
}

export function getPartnersId(id, params) {
  return request({
    url: `/api/guidebookv3/admin/partners/${id}/`,
    method: `get`,
    params,
  });
}

export function postPartners(data) {
  return request({
    url: `/api/guidebookv3/admin/partners/`,
    method: `post`,
    data,
  });
}

export function putPartnersId(id, data, params = id) {
  return request({
    url: `/api/guidebookv3/admin/partners/${id}/`,
    method: `put`,
    params,
    data,
  });
}

export function deletePartners(id, params) {
  return request({
    url: `/api/guidebookv3/admin/partners/${id}/`,
    method: "delete",
    params,
  });
}
